export default __webpack_public_path__ + "static/hero-37c1248409f49527ee2d94b1d1220e0d.webm";